if (!customElements.get('anso-sakura')) {
  customElements.define('anso-sakura', class extends HTMLElement {
    connectedCallback() {
      this.hero = this.closest('.anso-hero');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.visible = false;
      this.frame = 0;
      this.paused = false;
      this.toggle = this.hero.querySelector('[data-motion-toggle]');

      // Stable, irregular distribution; each piece has its own weight and flutter.
      let seed = 731;
      const random = () => {
        seed = (seed * 16807) % 2147483647;
        return (seed - 1) / 2147483646;
      };
      const petals = document.createDocumentFragment();
      for (let i = 0; i < 22; i++) {
        const petal = document.createElement('span');
        const depth = i % 7 === 0 ? 2 : i % 3 === 0 ? 0 : 1;
        const kind = i % 11 === 3 ? 'leaf' : i % 8 === 0 ? 'flower' : 'petal';
        const size = (kind === 'flower' ? 21 : kind === 'leaf' ? 18 : 12) + random() * 6 + depth * 3;
        const duration = 19 + random() * 12 - depth * 2;
        petal.className = `anso-sakura__fall anso-sakura__fall--${depth}`;
        petal.style.cssText = `--x:${(i * 61.803 + 8) % 100}%;--duration:${duration.toFixed(2)}s;` +
          `--delay:-${(random() * duration).toFixed(2)}s;--drift:${(30 + random() * 100).toFixed(1)}px;` +
          `--sway:${(12 + random() * 24).toFixed(1)}px;--flutter:${(3.4 + random() * 3.1).toFixed(2)}s;` +
          `--turn:${(random() * 360).toFixed(1)}deg;--size:${size.toFixed(1)}px;`;
        const drift = document.createElement('span');
        drift.className = 'anso-sakura__drift';
        const shape = document.createElement('span');
        shape.className = `anso-sakura__shape anso-sakura__${kind}`;
        drift.append(shape);
        petal.append(drift);
        petals.append(petal);
      }
      this.replaceChildren(petals);

      this.syncMotion = () => {
        this.running = this.visible && !document.hidden && !this.reducedMotion.matches && !this.paused;
        this.hero.dataset.sakuraRunning = String(this.running);
        if (this.toggle) {
          this.toggle.hidden = this.reducedMotion.matches;
          this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        }
        if (!this.running) this.resetPerspective();
      };
      this.toggle?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.syncMotion();
      }, { signal });
      this.reducedMotion.addEventListener('change', this.syncMotion, { signal });
      document.addEventListener('visibilitychange', this.syncMotion, { signal });

      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncMotion();
      });
      this.observer.observe(this.hero);
      this.resizeObserver = new ResizeObserver(([entry]) => {
        this.style.setProperty('--fall-distance', `${entry.contentRect.height + 120}px`);
      });
      this.resizeObserver.observe(this.hero);

      this.hero.addEventListener('pointermove', (event) => {
        if (!this.running || !this.finePointer.matches || event.pointerType === 'touch') return;
        const rect = this.hero.getBoundingClientRect();
        this.pointerX = (event.clientX - rect.left) / rect.width - 0.5;
        this.pointerY = (event.clientY - rect.top) / rect.height - 0.5;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.running) return;
          this.hero.style.setProperty('--sakura-x', `${this.pointerX * 20}px`);
          this.hero.style.setProperty('--sakura-y', `${this.pointerY * 14}px`);
        });
      }, { signal, passive: true });
      this.hero.addEventListener('pointerleave', () => {
        if (this.running) this.resetPerspective();
      }, { signal });
      this.syncMotion();
    }

    resetPerspective() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.hero.style.setProperty('--sakura-x', '0px');
      this.hero.style.setProperty('--sakura-y', '0px');
    }

    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      this.resizeObserver.disconnect();
      this.resetPerspective();
    }
  });
}
